export const csvTemplateHeaders = [
  { label: 'SiteId', key: 'siteId' },
  {
    label: 'ProgramAccessCode',
    key: 'programAccessCode',
  },
  {
    label: 'TrainingStartDate',
    key: 'trainingStartDate',
  },
  { label: 'ProgramStartDate', key: 'programStartDate' },
  {
    label: 'SchoolYearEnd',
    key: 'schoolYearEnd',
  },
]

export const resultsHeaders = [
  { label: 'Site Id', key: 'siteId' },
  { label: 'Site Name', key: 'siteName' },
  { label: 'Node Friendly Name', key: 'nodeFriendlyName' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'RowNumber', key: 'rowNumber' },
  { label: 'Error', key: 'error' },
]
